import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../@types/filter";
import { Paginated } from "../../@types/paginated";
import { apisiseci } from "../api";
import { useDefaultSearchParams } from "../../hooks/useSearchParams";
import { Reagendamento } from "../../@types/rescheduling";
import { useCurrentOrgao } from "../../hooks/useCurrentOrgao";

type Props = DefaultFilter & {
    orgao?: string;
    orgao_id?: string;
};

export function useReschedulingList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const currentOrgaoId = useCurrentOrgao();
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  // Adicionar filtro de órgão se disponível
  if (currentOrgaoId && !params.orgao) {
    params = { ...params, orgao_id: currentOrgaoId.toString() };
  }

  return useQuery<Paginated<Reagendamento>, Error>({
    queryKey: ["rescheduling", "list", params, currentOrgaoId],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<Reagendamento>>(
        "/cms/reagendamentos/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }
      );
      return response.data;
    },
  });
}
